import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle2, Target, UserRound, Sparkles } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { ComponentList } from "../components/site/Forfait";
import { api, store } from "../lib/api";
import NotFound from "./NotFound";

const ListCard = ({ icon: I, title, items, testid }) => (
  <div className="card-soft h-full p-7" data-testid={testid}>
    <I className="h-6 w-6 text-[#650D23]" strokeWidth={1.5} />
    <h3 className="mt-4 text-xl">{title}</h3>
    <ul className="mt-4 space-y-2.5">
      {items.map((t) => <li key={t} className="flex items-start gap-2.5 text-[.95rem] text-[#242020]/80"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#650D23]" />{t}</li>)}
    </ul>
  </div>
);

export default function ForfaitDetail() {
  const { slug } = useParams();
  const [f, setF] = useState(undefined);
  useEffect(() => {
    api.get(`/forfaits/${slug}`).then((r) => setF(r.data)).catch(() => setF(null));
  }, [slug]);
  if (f === null) return <NotFound />;
  if (!f) return <div className="h-[60vh] animate-pulse bg-[#FAF6F1]" />;
  const fromResult = store.get("struktiv_result") !== null;

  return (
    <PageFade>
      <section className="wave-bg">
        <Container className="grid gap-12 py-14 lg:grid-cols-[1.1fr_1fr] lg:py-20">
          <Reveal className="space-y-6">
            <Link to={fromResult ? "/resultat" : "/forfaits"} className="inline-flex items-center gap-2 text-sm text-[#650D23]" data-testid="forfait-back-link">
              <ArrowLeft className="h-4 w-4" /> {fromResult ? "Retour aux résultats" : "Tous les forfaits"}
            </Link>
            <p className="eyebrow">Forfait STRUKTIV</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl" data-testid="forfait-detail-name">{f.name}</h1>
            <p className="font-display text-xl text-[#650D23]">{f.tagline}</p>
            <p className="max-w-xl text-lg leading-relaxed text-[#242020]/80">{f.description}</p>
            <Link to={`/consultation?forfait=${f.slug}`} className="btn-primary" data-testid="forfait-consultation-button">Planifier une consultation <ArrowRight className="h-4 w-4" /></Link>
          </Reveal>
          <Reveal delay={0.1} className="rounded-[2rem] bg-[#650D23] p-8 text-[#FFFDFB] sm:p-10">
            <h2 className="text-2xl">Ce qui est inclus</h2>
            <div className="mt-6"><ComponentList items={f.components} light testid="forfait-detail-components" /></div>
            {f.addon && (
              <div className="mt-8 border-t border-[#FFFDFB]/20 pt-6" data-testid="forfait-detail-addon">
                <h3 className="text-xl">+ {f.addon.title}</h3>
                <p className="mt-2 text-sm text-[#EDE3D9]">{f.addon.description}</p>
                <ul className="mt-3 space-y-1.5 text-sm">{f.addon.items.map((t) => <li key={t}>• {t}</li>)}</ul>
              </div>
            )}
          </Reveal>
        </Container>
      </section>
      <Container className="grid gap-6 py-16 md:grid-cols-3 lg:py-24">
        <Reveal><ListCard icon={Target} title="Objectifs auxquels il peut répondre" items={f.objectives} testid="forfait-objectives" /></Reveal>
        <Reveal delay={0.08}><ListCard icon={UserRound} title="Profil potentiellement concerné" items={f.profile} testid="forfait-profile" /></Reveal>
        <Reveal delay={0.16}><ListCard icon={Sparkles} title="Avantages généraux" items={f.advantages} testid="forfait-advantages" /></Reveal>
      </Container>
      <Container className="pb-20">
        <p className="rounded-2xl border border-[#EDE3D9] bg-[#FAF6F1] p-6 text-sm text-[#242020]/75">Les renseignements présentés sont généraux et informatifs. Ils ne constituent pas une recommandation personnalisée ni une garantie de résultat. Une analyse complète de votre situation est nécessaire.</p>
      </Container>
    </PageFade>
  );
}
